import { render, staticRenderFns } from "./ChangeMailMagazine.vue?vue&type=template&id=14f16af4&"
import script from "./ChangeMailMagazine.vue?vue&type=script&lang=ts&"
export * from "./ChangeMailMagazine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports